var chunkToChildrenMap = {"8074":["6851","5139","4352","9925","3831"],"1591":["6851","5139","4352","9925","3831"],"8783":["6851","5139","4352","9925","3831"],"9626":["6851","5139","4352","9925","3831"],"4118":["6851","5139","4352","9925","3831"],"9102":["6851","5139","4352","9925","3831"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};